import request from '@/utils/request'


// 查询机构列表
export function listOrganization(query) {
  return request({
    url: '/organization/organization/list',
    method: 'get',
    params: query
  })
}

// 查询机构分页
export function pageOrganization(query) {
  return request({
    url: '/organization/organization/page',
    method: 'get',
    params: query
  })
}

// 查询机构详细
export function getOrganization(data) {
  return request({
    url: '/organization/organization/detail',
    method: 'get',
    params: data
  })
}

// 新增机构
export function addOrganization(data) {
  return request({
    url: '/organization/organization/add',
    method: 'post',
    data: data
  })
}

// 修改机构
export function updateOrganization(data) {
  return request({
    url: '/organization/organization/edit',
    method: 'post',
    data: data
  })
}

// 删除机构
export function delOrganization(data) {
  return request({
    url: '/organization/organization/delete',
    method: 'post',
    data: data
  })
}
